// extracted by mini-css-extract-plugin
export default {"footer":"_5D_mRHru","privacy-policy":"_5De2Cqzd","copy-right-text":"_5DQQACi7"};